import React from "react";
import SubcontractorPurchaseInvoiceSummaryTable from "../subcontractorPurchaseInvoiceSummaries/components/SubcontractorPurchaseInvoiceSummaryTable";
import HeaderContent from "../../components/layout/components/HeaderContent";

const SubcontractorRouteTransactionsList = () => {
  const breadcrumb = [
    {
      link: "/subcontractorRouteTransactions",
      title: "Subcontractor Route Transactions",
    },
  ];

  return (
    <>
      <HeaderContent
        breadcrumb={breadcrumb}
        headerTitle="Subcontractor Route Transactions"
        isNotHaveSchoolFilter
      />

      <SubcontractorPurchaseInvoiceSummaryTable
        referenceResource="subcontractorRouteTransactions"
        isShowTitle
      />
    </>
  );
};

export default SubcontractorRouteTransactionsList;
